/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_ParticipantBrokerAttestation_AcknowledgeParticipantBrokerAttestationInput } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAttestation_AcknowledgeParticipantBrokerAttestationInput';
import type { Wealthlane_CustomerService_Dtos_ParticipantBrokerAttestation_AcknowledgeParticipantBrokerAttestationResultDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAttestation_AcknowledgeParticipantBrokerAttestationResultDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBrokerAttestation_ParticipantBrokerAttestationAcknowledgementDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAttestation_ParticipantBrokerAttestationAcknowledgementDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantBrokerAttestationService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBrokerAttestation_ParticipantBrokerAttestationAcknowledgementDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiParticipantBrokerAttestationsAcknowledgements(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantBrokerAttestation_ParticipantBrokerAttestationAcknowledgementDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/participant-broker-attestations/acknowledgements',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBrokerAttestation_AcknowledgeParticipantBrokerAttestationResultDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiParticipantBrokerAttestationsAcknowledge(
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantBrokerAttestation_AcknowledgeParticipantBrokerAttestationInput,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantBrokerAttestation_AcknowledgeParticipantBrokerAttestationResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/participant-broker-attestations/acknowledge',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
